import i18next from './i18nextConfig';

export default function i18nextTranslate (i18nextTranslationKey, options) {
    return i18next.t(i18nextTranslationKey, options);
}